/* eslint-disable */

import React, {Component} from 'react';

let $ = window.jQuery;

export default class Camera extends Component {

	state = {
		buttonText : 'Take'
	}

	navigatorCheck = (e) => {
        navigator.getUserMedia = ( navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);
    };

    webCamera = (e) => {

        var constraints = {
            video: { width: 1280, height: 720 },
            audio: false
        };
        if(navigator.getUserMedia) {
            navigator.getUserMedia(
                constraints,
                function (stream) {
                    window.stream = stream;
                    var vendorURL = window.URL || window.webkitURL;
                    // document.getElementById('video').src = vendorURL.createObjectURL(stream);
                    document.getElementById('video').srcObject = stream;
                    document.getElementById('video').play();
                },
                function (error) {
                    console.log(error);
                });
        }
        
    };

    base64ToBlob = (base64) => {
        // write the bytes of the string to a typed array
        var ia = new Uint8Array(base64.length);
        for (var i = 0; i < base64.length; i++) {
            ia[i] = base64.charCodeAt(i);
        }

    	let imageToBlob = new Blob([ia],  {type: 'image/png', encoding: 'utf-8'});
    	return imageToBlob;
    }

    blobToFile = (theBlob) => {
		let file = new File([theBlob], 'medix.png', {type:"image/png"});
		return file;
	}

    usePhoto = (e) => {
        let photo = $('.photo_captured');
        
        if(photo.val() == '')
        {
            return;
        }

    	window.stream.getVideoTracks()[0].stop();
        // const url = appConfig.apiUrl + 'media/upload';
    	let imageInput = photo;
    	let o = imageInput.val();
    	let png = o.split(',')[1];
    	let s = window.atob(png);

    	let blob = this.base64ToBlob(s);
    	// let file = this.blobToFile(blob);

    	let form = new FormData();
		let files = blob;
		form.append('file',files);
		
        // submit
        this.props.onSavePhoto(form,e);
    }

    takePhoto = (e) => {
        var canvas = document.getElementById('canvas');
        var video = document.getElementById('video');

        $('#canvas').show(); // show first before getting offset
        $('#video').hide();
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

        var data = canvas.toDataURL('image/png',1.0);

        $('.photo_captured').val(data);
        
        this.setState({buttonText : 'Retake'});
        
    };

    retakePhoto = (e) => {
        $('#canvas').hide();
        $('#video').show();
        this.setState({buttonText : 'Take'});
    };

    clickHandler = () => {

    	$('#canvas').hide();
        $('#video').show();
        this.setState({buttonText : 'Take'});
    	
    	window.stream.getVideoTracks()[0].stop();
    	this.props.onCancel();
    }

    componentWillReceiveProps(nextProps) {
        // eslint-disable-next-line
    	if(nextProps.visibility == true)
    	{
    		this.webCamera();
    	}
    }

    componentWillMount() {
    	this.navigatorCheck();
    }

    componentDidMount() {
        $('#userProfileModal').on('hidden', () => {
            if(window.stream)
            {
                this.clickHandler();
            }
        })
    }

	render() {
		return (
			<div className="row" style={this.props.visibility ? {display : 'block'} : {display : 'none'}}>
				<div className="col-md-12">
					<video id="video" autoPlay loop muted style={{width:'100%'}}>Video stream not available.</video>
					<canvas id="canvas" width="470" height="350" style={{border: '1px dashed #dddddd',display : 'none'}}>&nbsp;</canvas>
				</div>
				<div className="col-md-4">
					<button className="btn btn-block" onClick={this.clickHandler}>Cancel</button>
				</div>
				<div className="col-md-4">
					<button className="btn green btn-block" onClick={this.state.buttonText == 'Take' ? this.takePhoto : this.retakePhoto} >{this.state.buttonText}</button>
				</div>
				<div className="col-md-4">
					<button className="btn green btn-block" onClick={this.usePhoto} value="upload">Done</button>
				</div>
				<input type="hidden" className="photo_captured" />
			</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/UserProfileModal/Camera.js
 **/